/**
 * App shell wiring. The router and the providers meet here so the
 * router can read from auth state without exposing the QueryClient to
 * everything above it.
 */
import { useAuthBootstrap } from '@/features/auth/hooks/use-auth';

import { AppProviders } from './providers';
import { AppRouter } from './router';

function AuthBootstrap({ children }: { children: React.ReactNode }) {
  useAuthBootstrap();
  return <>{children}</>;
}

export function App() {
  return (
    <AppProviders>
      <AuthBootstrap>
        <AppRouter />
      </AuthBootstrap>
    </AppProviders>
  );
}
